import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-mld',
  templateUrl: './events-mld.component.html',
  styleUrls: ['./events-mld.component.scss'],
})
export class EventsMldComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/mld/1.jpg',
      thumbnail: 'assets/img/school/events/mld/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/mld/2.jpg',
      thumbnail: 'assets/img/school/events/mld/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/mld/3.jpg',
      thumbnail: 'assets/img/school/events/mld/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/mld/4.jpg',
      thumbnail: 'assets/img/school/events/mld/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/mld/5.jpg',
      thumbnail: 'assets/img/school/events/mld/5.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/mld/6.jpg',
      thumbnail: 'assets/img/school/events/mld/6.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/mld/7.jpg',
      thumbnail: 'assets/img/school/events/mld/7.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/mld/8.jpg',
      thumbnail: 'assets/img/school/events/mld/8.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/mld/9.jpg',
      thumbnail: 'assets/img/school/events/mld/9.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/mld/10.jpg',
      thumbnail: 'assets/img/school/events/mld/10.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/mld/11.jpg',
      thumbnail: 'assets/img/school/events/mld/11.jpg',
      alt: 'Image 01',
    },
  ];
}
